import { useEffect } from "react";
import FoodPulseHomeV3 from "@/pages/FoodPulseHomeV3";

/**
 * FoodPulseHomeDispatcher — every visitor now sees the V3 redesign.
 *
 * The A/B dispatcher was retired in iter158c (per audit remediation Phase 0
 * "force everyone to V3"). We keep this component as the mounted route
 * element so the old `/food-pulse` entry point works, but it just renders
 * V3 unconditionally. The old editorial home is still reachable at
 * `/food-pulse/legacy` for direct preview.
 *
 * If a future audit round wants to bring the A/B toggle back, revert to
 * the earlier commit that consumed `/api/cms/homepage-variant` here.
 */
export default function FoodPulseHomeDispatcher() {
  // Reset any stale localStorage bucket a returning visitor may hold — the
  // legacy `fp_ab_id` used to pin ~50% of users to the old editorial home.
  useEffect(() => {
    try { localStorage.removeItem("fp_ab_id"); } catch { /* non-fatal */ }
  }, []);
  return <FoodPulseHomeV3 />;
}

